<template>
    <div id="teamlink" class="scc-teamlink-create" :class="`scc-teamlink-create--${backgroundColor}`">
        <TeamlinkCreateModal ref="modal" :game="game" />
        <h1 class="scc-teamlink-create__title">{{ title }}</h1>
        <p class="scc-teamlink-create__description">{{ description }}</p>
        <div class="scc-teamlink-create__buttons">
            <SccLink class="scc-teamlink-create__buttons-explain" to="#three-step">
                {{ explainButtonLabel }}
            </SccLink>
            <div
                class="scc-teamlink-create__buttons-generate"
                :class="`scc-teamlink-create__buttons-generate--${backgroundColor}`"
                @click="showModal"
            >
                {{ generateButtonLabel }}
            </div>
        </div>
    </div>
</template>

<script>
import './teamlink-create.scss';
import TeamlinkCreateModal from './TeamlinkCreateModal';
const values = ['primary', 'secondary', 'white', 'grey'];

export default {
    name: 'TeamlinkCreate',
    components: { TeamlinkCreateModal },
    __editor: {
        requiredData: ['game'],
        fields: {
            backgroundColor: {
                widget: 'select',
                values: values,
            },
            title: {
                widget: 'text',
            },
            description: {
                widget: 'textarea',
            },
            explainButtonLabel: {
                widget: 'text',
            },
            generateButtonLabel: {
                widget: 'text',
            },
        },
    },
    props: {
        game: {
            type: Object,
            required: true,
        },
        backgroundColor: {
            type: String,
            default: 'secondary',
        },
        title: {
            type: String,
            default: 'Teamlink',
        },
        description: {
            type: String,
            default:
                'Winnen doe je als team! Door een teamlink te genereren, maak je een unieke verkooplink aan voor jouw team. Alle loten die via deze link worden verkocht, worden toegekend aan jullie team.',
        },
        explainButtonLabel: {
            type: String,
            default: 'Hoe werkt het?',
        },
        generateButtonLabel: {
            type: String,
            default: 'Teamlink genereren',
        },
    },
    data() {
        return {
            showTeamlinkModal: false,
        };
    },
    methods: {
        showModal() {
            this.$refs.modal.show();
        },
    },
};
</script>
